import { IOffices } from '../../types/Office';

export const groupOfficesByRegion = (
  regionOffices: IOffices['RegionOffices']
) => {
  const regionsList: any[] = [];
  if (regionOffices && regionOffices.length) {
    for (let ri = 0; ri < regionOffices.length; ri++) {
      const region = Object.assign({}, { ...regionOffices[ri].Region });
      // @ts-ignore
      for (let bi = 0; bi < regionOffices[ri].Offices.length; bi++) {
        const office = Object.assign(
          {},
          // @ts-ignore
          { ...regionOffices[ri].Offices[bi] },
          {
            type: 'individual',
            groupName: region.Name,
          }
        );
        regionsList.push(office);
      }
    }
  }
  return regionsList;
};
